import { jsx as s } from "react/jsx-runtime";
import { forwardRef as l } from "react";
import n from "@mui/material/ListItemButton";
import d from "styled-components";
const m = {
  root: "listItemButtonRoot",
  dense: "listItemButtonDense",
  disabled: "listItemButtonDisabled",
  divider: "listItemButtonDivider",
  focusVisible: "listItemButtonFocusVisible",
  gutters: "listItemButtonGutters",
  selected: "listItemButtonSelected"
}, u = d(n).withConfig({
  displayName: "StyledListItemButton"
})([
  "&&.listItemButtonRoot{min-height:50px;font-size:",
  ";color:",
  ";line-height:1.2em;background-color:",
  ";border-radius:4px;}&&.listItemButtonDense{min-height:34px;}&&:focus-visible{outline:none;}&&.listItemButtonGutters{padding-left:8px;padding-right:8px;}&&.listItemButtonDivider{border-color:",
  ";}&&:hover:not(.listItemButtonDisabled),&&.listItemButtonFocusVisible:not(.listItemButtonDisabled){color:",
  ";background-color:",
  ";}&&.listItemButtonSelected:not(.listItemButtonDisabled){color:",
  ";background-color:",
  ";}&&.listItemButtonSelected:hover:not(.listItemButtonDisabled){color:",
  ";background-color:",
  ";}&&.listItemButtonDisabled{opacity:1;color:",
  ";}&&.listItemButtonSelected.listItemButtonDisabled{background-color:",
  ";color:",
  ";}"
], ({ theme: t }) => t.typography.body200.fontSize, ({ theme: t }) => t.text.primary, ({ theme: t }) => t.primaryBackground, ({ theme: t }) => t.primaryBorder, ({ theme: t, $hoverHighlight: o }) => o && t.colors.white, ({ theme: t, $hoverHighlight: o }) => o ? t.primaryHover : t.primaryBackground, ({ theme: t }) => t.colors.white, ({ theme: t }) => t.primaryFill, ({ theme: t }) => t.colors.white, ({ theme: t }) => t.primaryHover, ({ theme: t }) => t.secondaryDisabled, ({ theme: t }) => t.primaryDisabled, ({ theme: t }) => t.secondaryDisabled), a = /* @__PURE__ */ l(({ children: t, classes: o, hoverHighlight: e = !0, ...i }, r) => /* @__PURE__ */ s(u, {
  ...i,
  ref: r,
  classes: {
    ...m,
    ...o
  },
  $hoverHighlight: e,
  children: t
}));
a.displayName = "ListItemButton";
export {
  a as default
};
